import { render, staticRenderFns } from "./TheScreenProjectResult.vue?vue&type=template&id=00283ad2&"
import script from "./TheScreenProjectResult.vue?vue&type=script&lang=js&"
export * from "./TheScreenProjectResult.vue?vue&type=script&lang=js&"
import style0 from "./TheScreenProjectResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports